import { loadView } from '@/router/routerHelpers';
import { FEATURES } from '@/access/features';

const toolsRoutes = [
  {
    path: '/tools',
    component: {
      render: (c) => c('router-view'),
    },
    meta: {
      feature: FEATURES.CUSTOM_OBJECTS,
    },
    children: [
      {
        path: '',
        name: 'tools',
        meta: { feature: FEATURES.CUSTOM_OBJECTS },
        component: loadView('tools/Tools'),
      },
    ],
  },
];

export default toolsRoutes;
